import { Link } from 'gatsby';
import { EuiSpacer, EuiHideFor, EuiShowFor } from '@elastic/eui';
import NavButtons from 'components/Motion_Detection/Alarm_Notification/NavButtons';
import ForumBox from 'components/Motion_Detection/Alarm_Notification/ForumBox';
import Table from 'components/Motion_Detection/Alarm_Notification/SMTP_Servers/Table';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  EuiHideFor,
  EuiShowFor,
  NavButtons,
  ForumBox,
  Table,
  BreadCrumbs,
  SEOHelmet,
  React
};